














import { defineComponent } from '@vue/composition-api'
import { forbidPageSetup } from '../logic'
import props from '../props'

export default defineComponent({
  name: 'ForbidPage',
  props: props,
  setup: forbidPageSetup
})
